import { useIsMsalAuth } from '@equifinance/shared';
import { PaddedSection } from '../../../Account/components/Section';
import NotificationsSection from './SubSections/Notifications';
import SystemSettingsSubSection from './SubSections/SystemSettings';

export const systemSettingsRefName = 'system-settings';

export default function SystemSettingsSection() {
  const isInternalUser = useIsMsalAuth();

  return (
    <PaddedSection
      id={systemSettingsRefName}
      refName={systemSettingsRefName}
      title="System Settings"
      titleIcon={<></>}
    >
      {isInternalUser && <SystemSettingsSubSection />}
      <NotificationsSection />
    </PaddedSection>
  );
}
